import { View, Text, Pressable } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useAuth } from "@/providers/AuthProvider";

/**
 * Props for PlayingAsBanner component
 */
interface PlayingAsBannerProps {
  /**
   * Optional custom style for the container
   */
  style?: object;
}

/**
 * PlayingAsBanner Component
 * 
 * Shows a prominent banner when the user is switched to a dependent profile.
 * This banner is displayed at the top of screens to remind the user they're
 * acting as a child.
 */
export function PlayingAsBanner({ style }: PlayingAsBannerProps) {
  const { activeProfile, isSwitched, switchBackToSelf } = useAuth();

  // Only show when switched to a dependent
  if (!isSwitched || !activeProfile) return null;

  return (
    <View
      className="flex-row items-center justify-between px-4 py-2"
      style={[
        {
          backgroundColor: "#1D4ED8",
        },
        style,
      ]}
    >
      <View className="flex-row items-center flex-1">
        <Ionicons name="person-circle" size={20} color="#FFFFFF" />
        <Text className="text-white font-medium ml-2">
          Je speelt als {activeProfile.full_name}
        </Text>
      </View>

      <Pressable
        onPress={switchBackToSelf}
        className="flex-row items-center px-3 py-1 rounded-full active:opacity-70"
        style={{ backgroundColor: "rgba(255,255,255,0.2)" }}
        accessibilityRole="button"
        accessibilityLabel="Terug naar eigen profiel"
      >
        <Ionicons name="arrow-back" size={14} color="#FFFFFF" />
        <Text className="text-white text-sm font-medium ml-1">Terug</Text>
      </Pressable>
    </View>
  );
}

export default PlayingAsBanner;

